import React, { CSSProperties, ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/pro-regular-svg-icons/faChevronUp';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown'

import { useToggle } from '../hooks/useToggle';

type Props = {
  headerText: string | JSX.Element;
  children: ReactNode;
  style?: CSSProperties;
  headerTextClasses?: string;
};

export const Accordion = ({ headerText, headerTextClasses, children, style }: Props): JSX.Element => {
  const [isAccordionOpen, setIsAccordionOpen] = useToggle();
  const accordionIcon = isAccordionOpen ? faChevronUp : faChevronDown;

  return (
    <div className='flex flex-col' style={style}>
      <button onClick={setIsAccordionOpen} type='button' className='pt-4 pb-3 cursor-pointer content-center'>
        <div className='flex'>
          <h1 className={`text-left text-2xl font-semibold mt-1 mb-0${headerTextClasses ? ` ${headerTextClasses}` : ''}`}>{headerText}</h1>
          <div className='flex-1 text-right text-lg'>
            <FontAwesomeIcon icon={accordionIcon} />
          </div>
        </div>
      </button>
      {isAccordionOpen && <div>{children}</div>}
    </div>
  );
};
